import { gql } from '@apollo/client';

export const QUERY_GET_ZIP_FILE_SIGNED_URL = gql`
    query Query($data: [Int!]!) {
        getZipFileSignedUrl(data: $data)
    }
`;
